import {
  memberSignatureLineResponseSchema,
  signatureSettingsResponseSchema,
  updateSignatureLineRequestSchema,
  updateSignatureSettingsRequestSchema,
  type MemberSignatureLineResponse,
  type SignatureSettingsResponse,
  type UpdateSignatureSettingsRequest,
} from '@emr/shared';

import { apiRequest } from './client.ts';

export type {
  SignatureSettingsResponse,
  UpdateSignatureSettingsRequest,
  MemberSignatureLineResponse,
};

/** `GET /api/profile/signature` — the caller's own current mark and (admin-set, read-only from
 * here) signature line. Self-service, no capability. */
export function getOwnSignature(signal?: AbortSignal): Promise<SignatureSettingsResponse> {
  return apiRequest(
    '/api/profile/signature',
    signatureSettingsResponseSchema,
    signal === undefined ? {} : { signal },
  );
}

/** `PATCH /api/profile/signature` — set the caller's own mark. Never touches `signatureLine`; the
 * server-side schema has no field for it, per `server/src/auth/signatureRoutes.ts`'s own header. */
export function updateOwnSignature(
  input: UpdateSignatureSettingsRequest,
): Promise<SignatureSettingsResponse> {
  const body = updateSignatureSettingsRequestSchema.parse(input);
  return apiRequest('/api/profile/signature', signatureSettingsResponseSchema, {
    method: 'PATCH',
    body,
  });
}

/** `GET /api/orgs/members/:userId/signature-line` — admin-only (`org:manage_members`). */
export function getMemberSignatureLine(
  userId: string,
  signal?: AbortSignal,
): Promise<MemberSignatureLineResponse> {
  return apiRequest(
    `/api/orgs/members/${userId}/signature-line`,
    memberSignatureLineResponseSchema,
    signal === undefined ? {} : { signal },
  );
}

/** `PATCH /api/orgs/members/:userId/signature-line` — admin-only. `signatureLine: null` clears it. */
export function updateMemberSignatureLine(
  userId: string,
  signatureLine: string | null,
): Promise<MemberSignatureLineResponse> {
  const body = updateSignatureLineRequestSchema.parse({ signatureLine });
  return apiRequest(
    `/api/orgs/members/${userId}/signature-line`,
    memberSignatureLineResponseSchema,
    {
      method: 'PATCH',
      body,
    },
  );
}
